import React from "react";

function UpdateOSField({ value, onChange, disabled }) {

    return (
        <div className="oct-shared-popup__field">
            <label className="oct-shared-popup__label" htmlFor="scan-os">
                Host OS <span className="oct-shared-popup__required-mark">*</span>
            </label>
            <textarea
                className="oct-shared-popup__textarea"
                id="scan-os"
                value={value}
                autoComplete="off"
                disabled={disabled}
                rows={5}
                placeholder="Describe the host operating system"
                onChange={event => onChange(event.target.value)}
            />
        </div>
    )

}


export default UpdateOSField;
